export default __webpack_public_path__ + "static/media/logo.59722135.png";